import { tNotificationsProps } from '../../Notification.types.ts';
import { eNotificationEvent } from '../../Notification.events.ts';
import { useNotificationsContext } from '../../Notifications.constants.ts';
import AgendaToast from '../AgendaToast/AgendaToast.component.tsx';
import type { tAgendaEventNotification } from '../../Notification.types.ts';
import type { tGenericNotification } from 'src/notifications/AgendaNotifications.types';
import './NotificationsSideBar.styles.scss';

/**
 * AGI-346 — this layer used to render EVERY socket notification as a toast.
 * The agenda notifications now live in the Alert Center panel, where they can
 * be found again after the fact, so the only type left here is the calendar
 * reminder.
 *
 * The reminder stays a toast ON PURPOSE, and it also appears as a tray row —
 * the same notification in two places. Counted before deciding:
 * `calendar.event.reminder_triggered` carries 153k notifications across 3.2k
 * workspaces, and 260 workspaces still have no bell to receive it (the
 * `leads_alert-center` grant stopped on 2026-08-25). Silencing a feature that
 * works, so a new surface can debut alone, is the wrong trade. The duplicate
 * is the deliberate cost of not blinding anyone.
 *
 * One record, two surfaces, ONE dismiss: both controls call the same
 * `closeNotification`, so clearing it in either place clears it in both.
 *
 * Anything else renders nothing here. That is not an oversight — the five
 * agenda types have a home now, and a toast for them would be the second
 * surface this ticket exists to remove.
 */
function renderNotification(notification: tGenericNotification) {
  if (
    notification.event !== eNotificationEvent.CALENDAR_EVENT_REMINDER_TRIGGERED
  ) {
    return null;
  }

  return (
    <AgendaToast
      key={notification.id}
      notification={notification as tAgendaEventNotification}
    />
  );
}

export default function NotificationsSidebar(props: tNotificationsProps) {
  const { currentNotifications } = useNotificationsContext();
  return (
    <>
      <div className="NotificationsSidebar">
        {currentNotifications?.map(renderNotification)}
      </div>
      {props.children}
    </>
  );
}
